import { render, staticRenderFns } from "./profile-upgrade-card.vue?vue&type=template&id=c4b06b52&scoped=true&"
import script from "./profile-upgrade-card.vue?vue&type=script&lang=js&"
export * from "./profile-upgrade-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b06b52",
  null
  
)

export default component.exports